export default ({ COLORS }) => ({
  container: ({ size, printMode }) => ({
    fontSize: printMode ? '18px' : size(2, { scaleFactor: 'lg' }),
    lineHeight: '1.2'
  }),
  html: {
    '@media print': {
      fontSize: '.8em'
    },
    '& p': {
      margin: '0',
      minHeight: '1.2em'
    },
    '& a': {
      color: 'inherit'
    },
    '& ul': {
      listStyle: 'none',
      margin: '0',
      padding: '0 0 0 1em',
      '& li:after': {
        content: '""',
        position: 'absolute',
        left: '-.9em',
        top: '.4em',
        width: '.3em',
        height: '.3em',
        borderRadius: '.3em',
        background: COLORS.BLUE.NORMAL
      }
    },
    '& ol': {
      listStyle: 'none',
      margin: '0',
      padding: '0 0 0 1.4em',
      counterReset: 'item',
      '& li:after': {
        position: 'absolute',
        left: '-1.4em',
        top: '0',
        content: 'counter(item) ". "',
        counterIncrement: 'item',
        fontWeight: 'bold',
        color: COLORS.BLUE.NORMAL
      }
    },
    '& li': {
      margin: '.7em 0',
      position: 'relative'
    }
  },
  contrast: {
    '& ul': {
      '& li:after': {
        background: '#fff'
      }
    },
    '& ol': {
      '& li:after': {
        color: '#fff'
      }
    }
  }
})
